import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	isOpenHomePage: true,
	isOpenPricePage: false,
}

const pageSlices = createSlice({
	name: 'pages',
	initialState,
	reducers: {
		togglePricePage(state) {
			state.isOpenPricePage = !state.isOpenPricePage
		},
		toggleHomePage(state) {
			state.isOpenHomePage = !state.isOpenHomePage
		},
	},
})

export const { toggleHomePage, togglePricePage } = pageSlices.actions
export default pageSlices.reducer
